import React, { useEffect } from "react";
import EmpresaListTemplate from "../components/templates/EmpresaListTemplate";
import { useNavigate } from "react-router-dom";
import { useSession } from "../context/SessionContext";
import { PropagateLoader } from "react-spinners";

const EmpresaList = () => {
    const { user } = useSession();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user?.role !== "Admin" && user.role !== "Lawyer") {
            navigate("/dashboard");
        }
    }, [user, navigate]);

    if (!user || (user?.role !== "Admin" && user.role !== "Lawyer")) {
        return null;
    }

    return (
        <div>
            {!user ?
                <div className="w-full flex justify-center items-center">
                    <PropagateLoader color="red"/>
                </div>
            :
                <EmpresaListTemplate user={user} />
            }
        </div>
    )
};

export default EmpresaList;